'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var renderItems = function renderItems(children, childClassName, firstChildClassName, lastChildClassName) {
  return _react.Children.map(children, function (child, i) {
    if (child == null) {
      return null;
    }

    var computedChildClassName = void 0;
    if (i === 0 && firstChildClassName != null) {
      computedChildClassName = firstChildClassName;
    } else if (!children.hasOwnProperty(i + 1) && lastChildClassName != null) {
      computedChildClassName = lastChildClassName;
    } else {
      computedChildClassName = childClassName;
    }

    var className = (0, _classnames2.default)('uiListItem', 'private-list__item', computedChildClassName);

    return _react2.default.createElement(
      'li',
      { className: className },
      child
    );
  });
};

var UIList = (0, _react.forwardRef)(function (props, ref) {
  var ordered = props.ordered,
      styled = props.styled,
      inline = props.inline,
      className = props.className,
      children = props.children,
      childClassName = props.childClassName,
      firstChildClassName = props.firstChildClassName,
      lastChildClassName = props.lastChildClassName,
      use = props.use,
      rest = _objectWithoutProperties(props, ['ordered', 'styled', 'inline', 'className', 'children', 'childClassName', 'firstChildClassName', 'lastChildClassName', 'use']);

  var computedClassName = (0, _classnames2.default)('uiList', {
    'private-list--inline': inline || use === 'inline-divided',
    'private-list--inline-divided': use === 'inline-divided',
    'private-list--unstyled': !styled
  }, className);

  var renderedItems = renderItems(children, childClassName, firstChildClassName, lastChildClassName);

  var List = ordered ? 'ol' : 'ul';

  return _react2.default.createElement(
    List,
    _extends({}, rest, { className: computedClassName, ref: ref }),
    renderedItems
  );
});

UIList.propTypes = {
  childClassName: _propTypes2.default.string,
  children: _propTypes2.default.node,
  firstChildClassName: _propTypes2.default.string,
  inline: _propTypes2.default.bool.isRequired,
  lastChildClassName: _propTypes2.default.string,
  ordered: _propTypes2.default.bool.isRequired,
  styled: _propTypes2.default.bool.isRequired,
  use: _propTypes2.default.oneOf(['default', 'inline-divided'])
};

UIList.defaultProps = {
  inline: false,
  ordered: false,
  styled: false,
  childClassName: '',
  use: 'default'
};

UIList.displayName = 'UIList';

exports.default = UIList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/list/UIList.js
// module id = 540
// module chunks = 177